import { enParameters } from 'enums/enParameters';

export type IParameters = Partial<Record<enParameters, string>>;

export const sanitizeParameters = (obj: IParameters): IParameters => {
  const clearedArray = Object.entries(obj).filter(([, v]) => !!v);
  return Object.fromEntries(clearedArray);
};
